import {initMagnificPopupPlugin} from "./plugin";

export function initMagnificPopups($) {
    initMagnificPopupPlugin($)

    $( 'a[data-rel^="penci-gallery-image-content"], .penci-enable-lightbox .gallery-item a' ).magnificPopup(
        {
             type               : 'image',
             closeOnContentClick: true,
             closeBtnInside     : false,
             fixedContentPos    : true,
             image              : {
                 verticalFit: true,
                 titleSrc: 'data-cap'
             },
             gallery : {
                 enabled: true
             },
             zoom               : {
                 enabled : true,
                 duration: 300
             }
         } );
}